import * as React from "react";
import { ReactNode } from "react";
import { Divider, Paper, Typography } from "@mui/material";

interface SectionPaperProps {
  title: ReactNode;
  children: ReactNode;
}

const SectionPaper = ({ title, children }: SectionPaperProps) => (
  <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
    <Typography variant="h6" gutterBottom>
      {title}
    </Typography>
    <Divider sx={{ mb: 2 }} />
    {children}
  </Paper>
);

export default SectionPaper;
